import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack } from '@yonderland/andes-react';
import { mapTextColorToDividerLineColor } from './list.utils';
import { ListItemContent } from './ListItemContent';
export const VerticalList = ({ items }) => {
    return (_jsx(Stack, { direction: "col", children: items.map((item, index) => (_jsxs(Stack, { direction: "col", children: [_jsx(ListItemContent, { item: item }), item.borderBottom && (_jsx(Divider, { color: item.textColor ? mapTextColorToDividerLineColor[item.textColor] : undefined }))] }, `list-item-${index}`))) }));
};
